
import {defineComponent, ref} from "vue";

export default defineComponent( {
  name: "reminder",
  props: {
    reminderData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    console.log('props=====================,', props)
    const reminder = ref(props.reminderData)

    return {
      reminder
    }

  }
})
